import React, { useEffect, useState } from 'react';
import { Loader } from '../../../../../../Common';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import SearchSelectList from '../Comman/SearchSelectedList';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { adminAPIURL } from '../../../../../../Config';
import { RxCross2 } from 'react-icons/rx';
import airplane from '../../../../../../../assets/images/airplane.svg';
import AddAirport from './Components/AddAirport';
import { GET_COORDINATES_EMPTY, SAVE_DRAFT_CONFIGURATION, UPDATE_DRAFT_CONFIGURATION } from '../../../../../../../store/actions';
import { ChevronLeft } from 'react-feather';
import cogoToast from 'cogo-toast';
import TypeCard from '../Comman/TypeCard';

const initialState = {
  id: '',
  name: null,
  code: '',
  placeId: '',
  address: '',
  latitude: '',
  longitude: '',
  terminals: [{ name: null, latitude: '', longitude: '', placeId: '' }],
};

const SelectAirport = ({ state, setState, setFormCount, isDraftConfiguration, configuration }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [selectedAirports, setSelectedAirports] = useState<any>([]);
  const [add, setAdd] = useState(false);
  const [airport, setAirport] = useState(initialState);
  const [isUpdate, setIsUpdate] = useState(false);
  const [errors, setErrors] = useState({
    name: '',
    code: '',
    latitude: '',
    longitude: '',
    terminals: [], // Array of objects per terminal
  });

  useEffect(() => {
    setSelectedAirports(state?.vendorPricing?.airports ?? []);
  }, []);

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const removeAirport = airportToRemove => {
    setSelectedAirports(prev => prev.filter(airport => airport.id !== airportToRemove.id));
  };

  const updateAirport = airportToUpdate => {
    setAirport({
      id: airportToUpdate?.id,
      name: {
        value: airportToUpdate?.id,
        label: airportToUpdate?.name,
      },
      code: airportToUpdate?.code,
      latitude: airportToUpdate?.latitude,
      placeId: airportToUpdate?.placeId,
      address: airportToUpdate?.address,
      longitude: airportToUpdate?.longitude,
      terminals: airportToUpdate?.terminals?.map(terminal => {
        return {
          name: {
            value: terminal?.name,
            label: terminal?.name,
          },
          latitude: terminal?.latitude,
          longitude: terminal?.longitude,
          placeId: terminal?.placeId,
        };
      }) ?? [{ name: null, latitude: '', longitude: '' }],
    });
    setIsUpdate(true);
    setAdd(true);
  };

  const validateAirport = airport => {
    const newErrors = {
      name: airport.name ? '' : 'Airport name is required',
      code: airport.code ? '' : 'Airport code is required',
      latitude: airport.latitude ? '' : 'Latitude is required',
      longitude: airport.longitude ? '' : 'Longitude is required',
      terminals: [],
    };

    airport.terminals.forEach((terminal, i) => {
      const tErrors = {
        name: terminal.name ? '' : 'Name required',
        latitude: terminal.latitude ? '' : 'Latitude required',
        longitude: terminal.longitude ? '' : 'Longitude required',
      };
      newErrors.terminals.push(tErrors);
    });

    setErrors(newErrors);

    // check if any error exists
    const hasError =
      Object.values(newErrors).some(val => typeof val === 'string' && val !== '') ||
      newErrors.terminals.some(t => Object.values(t).some(v => v !== ''));

    return hasError;
  };

  const handleAirport = () => {
    const error = validateAirport(airport);
    if (error) {
      return; // prevent adding
    }

    if (isUpdate) {
      const updatedAirport = {
        id: airport.name?.value,
        name: airport?.name?.label,
        code: airport?.code,
        address: airport?.address ?? '',
        placeId: airport?.placeId ?? '',
        terminals:
          airport?.terminals?.map(terminal => ({
            name: terminal?.name?.value,
            latitude: terminal?.latitude,
            longitude: terminal?.longitude,
            placeId: terminal?.name?.completeData?.placeId || terminal?.placeId,
          })) ?? [],
        tag: 'partially_configured',
      };

      setSelectedAirports(prev => prev.map(item => (item.id === airport.id ? { ...item, ...updatedAirport } : item)));
    } else {
      setSelectedAirports(prev => [
        ...prev,
        {
          ...airport,
          id: Math.random().toString(36).substring(2, 10),
          name: airport?.name?.completeData?.structuredFormatting?.mainText,
          address: airport?.name?.completeData?.structuredFormatting?.secondaryText ?? '',
          placeId: airport?.name?.completeData?.placeId ?? '', // Find Airports API Field: place_id
          terminals:
            airport?.terminals?.map(terminal => {
              return {
                name: terminal?.name?.value, // Find Airports API Field: structuredFormatting-> main_text
                latitude: terminal?.latitude, // Get Terminal Coordinates API Field: latitude
                longitude: terminal?.longitude, // Get Terminal Coordinates API Field: longitude
                placeId: terminal?.name?.completeData?.placeId, // Find Terminals API Field: place_id
              };
            }) ?? [],
          tag: 'partially_configured',
        },
      ]);
    }

    setAirport(initialState);
    setAdd(false);
    setIsUpdate(false);
    dispatch({
      type: GET_COORDINATES_EMPTY,
    });
  };

  const saveAsDraftHandler = () => {
    if (selectedAirports?.length == 0) {
      cogoToast.error('Please select at least one airport to proceed further');
      return;
    }
    setState(prev => ({ ...prev, vendorPricing: { ...prev?.vendorPricing, airports: selectedAirports } }));
    dispatch({
      type: SAVE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            client: state?.client,
            project: state?.project,
            benefit: state?.benefit,
            benefitGroup: state?.benefitGroup,
            vendorPricing: {
              airports: selectedAirports,
            },
            page: 6,
          },
          configuration_type: 'program_onboarding',
          status: 'DRAFT',
        },
      },
    });
  };

  const updateAsDraftHandler = () => {
    if (selectedAirports?.length == 0) {
      cogoToast.error('Please select at least one airport to proceed further');
      return;
    }
    setState(prev => ({ ...prev, vendorPricing: { ...prev?.vendorPricing, airports: selectedAirports } }));
    dispatch({
      type: UPDATE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            client: state?.client,
            project: state?.project,
            benefit: state?.benefit,
            benefitGroup: state?.benefitGroup,
            vendorPricing: {
              airports: selectedAirports,
            },
            page: 6,
          },
          id: configuration?.id,
          configuration_type: 'program_onboarding',
          status: 'DRAFT',
        },
      },
    });
  };

  const handleSubmit = () => {
    if (selectedAirports?.length == 0) {
      cogoToast.error('Please select at least one airport to proceed further');
      return;
    }
    const selectedIds = selectedAirports.map(a => a.id);
    setState(prev => {
      // Keep existing airport objects (no replacing)
      const existingAirports = (prev?.vendorPricing?.airports || []).filter(a => selectedAirports.some(sa => sa.id === a.id));
      // Add brand new airports from selectedAirports (full object from selectedAirports)
      const newAirports = selectedAirports.filter(sa => !existingAirports.some(ea => ea.id === sa.id));

      return {
        ...prev,
        vendorPricing: {
          ...prev?.vendorPricing,
          airports: [...existingAirports, ...newAirports], // merge without replacing existing objects
          vendors:
            prev?.vendorPricing?.vendors?.map(vendor => ({
              ...vendor,
              zones: vendor?.zones?.filter(zone => selectedIds.includes(zone?.airport?.id)) || [],
            })) || [],
        },
        clientPricing: {
          ...prev?.clientPricing,
          airports: prev?.clientPricing?.airports?.filter(a => selectedIds.includes(a.id)) || [],
        },
      };
    });

    setFormCount((prev: number) => prev + 1);
  };

  return (
    <div className="page-content">
      {loading && <Loader zIndex={true} />}

      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Airport Configuration Setup`}
              navigationby={breadcrumNavigationHandler}
              navigation={['Management', 'Program', 'Onboarding', 'Select Airport']}
            />
          </div>
        </div>

        <Card>
          <CardHeader className="d-flex justify-content-between p-0">
            <h5 className="m-0 fw-semibold px-3">Search and select airports to manage</h5>
            <TypeCard typeName={'Client'} name={state?.client?.name} />
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              {/* Search Airports */}
              <Col md="8">
                <SearchSelectList
                  label="Search Airport"
                  subLabel="Search and select airports to manage"
                  placeholder="Type airport name..."
                  selectedItems={selectedAirports}
                  onSelect={setSelectedAirports}
                  searchApi={async query => {
                    const res = await axios({
                      method: 'GET',
                      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/airports`,
                      headers: {
                        'Project-Code': `ADMIN_ACCESS`,
                      },
                      params: {
                        search: query, // Changed `name` to `searchName`
                        // draft: true,
                      },
                      withCredentials: true,
                    });
                    return res?.data?.data;
                  }}
                  renderItem={item => (
                    <div className="d-flex gap-2 align-items-center">
                      <img src={airplane} alt="" />
                      {item.name}
                    </div>
                  )}
                  name="airport"
                  setAdd={setAdd}
                />
              </Col>

              {/* Selected Airports */}
              <Col md="4">
                <Card className="border rounded-3 p-3 mt-3 mb-3" style={{ height: '170px' }}>
                  <h6 className="fw-semibold">Selected Airports</h6>
                  <p className="text-muted mb-2 small">Currently selected airports ({selectedAirports?.length})</p>

                  {selectedAirports?.length > 0 ? (
                    <div className="mt-1 airport-list">
                      {selectedAirports.map(airport => (
                        <div
                          key={airport.id}
                          style={{ background: '#EAEDF5', borderRadius: '5px' }}
                          className="d-flex justify-content-between align-items-center mb-1 p-1 ps-3 px-3"
                        >
                          <div className="d-flex align-items-center gap-2">
                            <img src={airplane} alt="" />
                            <p className="m-0 fs-12">{airport?.name}</p>
                          </div>
                          <div className="d-flex gap-2">
                            {airport?.tag === 'partially_configured' && (
                              <i className="ri-edit-line cursor-pointer" onClick={() => updateAirport(airport)}></i>
                            )}
                            <i className="ri-close-line cursor-pointer" onClick={() => removeAirport(airport)}></i>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-center text-muted small mt-2">No Airports selected</p>
                  )}
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {add && (
          <Card className="p-3">
            <CardHeader tag="h5" className="border-bottom pb-2">
              Add Airport
            </CardHeader>
            <CardBody>
              <AddAirport airport={airport} setAirport={setAirport} errors={errors} setErrors={setErrors} isUpdate={isUpdate} />
              <div className="d-flex justify-content-between mt-4">
                <Button
                  className="btn btn-primary btn-light"
                  onClick={() => {
                    setAdd(false);
                    setIsUpdate(false);
                    setAirport(initialState);
                  }}
                >
                  Cancel
                </Button>
                <Button color="success" onClick={handleAirport}>
                  {isUpdate ? 'Update Airport' : 'Add Airport'}
                </Button>
              </div>
            </CardBody>
          </Card>
        )}

        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount((prev: number) => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>

          <div className="d-flex gap-2">
            {isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '150px' }} color="primary" onClick={updateAsDraftHandler}>
                Update As Draft
              </Button>
            )}

            {!isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '130px' }} color="primary" onClick={saveAsDraftHandler}>
                Save As Draft
              </Button>
            )}

            <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
              Manage Zones
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SelectAirport;
